<template>
  <div class="content-block">
    <div class="asd-form-section">
      <div class="section-title">
        <h5>
          <i class="fas fa-users"></i>
          ACL Skupiny uživatelů
        </h5>
        <div class="section-title-controls">
          <ActiveButton class="asd-btn-confirm asd-btn-single-icon"
                        :click="save"
          >
            <i class="fas fa-save"></i>
          </ActiveButton>
        </div>
      </div>

      <table class="asd-table">
        <thead>
          <tr class="table-heading">
            <th>
              <ActiveButton class="asd-btn-confirm asd-btn-single-icon"
                            :click="add"
              >
                <i class="fas fa-plus"></i>
              </ActiveButton>
            </th>
            <td style="min-width: 200px">
              Název
            </td>
            <td style="min-width: 300px">
              Akce
            </td>
            <td>Viditelnost vlasnosti</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="g in groups"
              :key="g.id"
          >
            <td>
              <ActiveButton
                class="asd-btn-delete"
                :click="deleteGroup"
                :fncParam="g.id"
                confirmText="Opravdu chcete smazat tuto skupinu?"
              >
                <i class="fas fa-trash"></i>
              </ActiveButton>
            </td>
            <td>
              <input id="lastname"
                     v-model="g.name"
                     type="text"
                     class="asd-input"
              />
            </td>
            <td>
              <Multiselect
                :id="`group-${g.id}`"
                v-model="g.actions"
                :max="-1"
                label="label"
                trackBy="id"
                valueByPath="id"
                :options="availableGroups"
                :allowEmpty="true"
              >
              </Multiselect>
            </td>
            <td class="visibilities-editor">
              <div
                v-for="pt in $store.getters.propertyTypes"
                :key="`pt-${pt.key}`"
                class="visibility-box"
                :class="`visibility-${visibility(pt.id, g.groupPropertyTypes)}`"
                @click="changeVisibility(pt.id, g.groupPropertyTypes, g.id)"
              >
                {{ pt.name }}
                <i v-if="visibility(pt.id, g.groupPropertyTypes) === 0"
                   class="fas fa-pencil-alt"
                ></i>
                <i v-if="visibility(pt.id, g.groupPropertyTypes) === 1"
                   class="fas fa-eye"
                ></i>
                <i v-if="visibility(pt.id, g.groupPropertyTypes) === 2"
                   class="fas fa-eye-slash"
                ></i>
                <i v-if="visibility(pt.id, g.groupPropertyTypes) === 3"
                   class="fas fa-times"
                ></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="asd-form-section">
      <div class="section-title">
        <h5>
          <i class="fas fa-info"></i>
          Nápověda
        </h5>
        <div class="section-title-controls"></div>
      </div>
      <h6>
        <i class="fas fa-dot-circle"></i>
        Viditelnost vlasnosti
      </h6>
      <p class="asd-form">
        <i class="fas fa-pencil-alt visibility-0"></i>
        Vlastnost je plně viditelná a je jí možno editovat. Toto je výchozí chovaní.
      </p>
      <p class="asd-form">
        <i class="fas fa-eye visibility-1"></i>
        Vlastnost je pouze plně viditelná.
      </p>
      <p class="asd-form">
        <i class="fas fa-eye-slash visibility-2"></i>
        Vlastnost se propíše ale její hodnota je nulová. V GUI se pak sloupeček s touto vlastností zobrazí ale
        místo hodnoty se zobrazí informační text že hodnota je skrytá.
      </p>
      <p class="asd-form">
        <i class="fas fa-times visibility-3"></i>
        Vlastnost není vůbec vidět. Systém se chová jako kdyby vlastnost vůbec neexistovala a nevrátí k ní
        žádnou hodnotu.
      </p>
      <h6>
        <i class="fas fa-dot-circle"></i>
        Akce
      </h6>
      <p v-for="ag in availableGroups"
         :key="ag.id"
         class="asd-form"
      >
        <strong>{{ ag.label }}</strong>
        {{ ag.info }}
      </p>
    </div>
  </div>
</template>

<script>
import { get, filter, head, map, orderBy } from 'lodash'
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext'
import ActiveButton from 'CORE/components/form/active-button'

export default {
    name: 'Groups',
    components: {
        Multiselect,
        ActiveButton,
    },
    data() {
        return {
            groups: [],
        }
    },
    computed: {
        availableGroups() {
            return [
                { id: 'LOGIN', label: 'Prihlasit se', info: 'Uživatel se může přihlásit.' },

                {
                    id: 'READ_OTHER_USERS',
                    label: 'Číst ostatní uživatele',
                    info: 'Uživatel může číst data ostatních uživatelů mimo id a emailu.',
                },
                {
                    id: 'EDIT_OTHER_USERS',
                    label: 'Editovat ostatní uživatele',
                    info: 'Uživatel může editovat data ostatních uživatelů.',
                },

                { id: 'EDIT_PROPERTIES', label: 'Editovat vlasnosti', info: 'Uživatel může editovat vlastnosti' },
                { id: 'EDIT_SETTINGS', label: 'Editovat nastavení', info: 'Uživatel může editovat nastavení' },

                { id: 'ADD_PROJECT', label: 'Přidávat projekty', info: 'Uzivatel muze pridavat novy projekt' },
                { id: 'EDIT_PROJECT', label: 'Editovat projekty', info: 'Uživatel může editovat projekty' },
                {
                    id: 'DELETE_PROJECT',
                    label: 'Smazat (archivovat) projekty',
                    info: 'Uživatel může přesunout projekt do archivu',
                },
                {
                    id: 'MANAGE_PROJECT_TYPES',
                    label: 'Spravovat typy projektů',
                    info: 'Umožňuje spravovat typy projektů',
                },

                { id: 'ADD_TASK', label: 'Přidávat úkoly', info: 'Uživatel může přidávat úkoly' },
                { id: 'EDIT_TASK', label: 'Editovat úkoly', info: 'Uživatel může editovat úkoly' },
                { id: 'DELETE_TASK', label: 'Smazat úkoly', info: 'Uživatel může mazat úkoly' },
                { id: 'MANAGE_TASK_TYPES', label: 'Spravovat typy úkolů', info: 'Umožňuje spravovat typy úkolů' },

                { id: 'ADD_RESOURCE', label: 'Přidávat zdroje', info: 'Umožňuje přidávat zdroje' },
                { id: 'EDIT_RESOURCE', label: 'Editovat zdroje', info: 'Umožňuje editovat zdroje' },
                { id: 'MANAGE_RESOURCE_TYPES', label: 'Spravovat typy zdrojů', info: 'Umožňuje spravovat typy zdrojů' },

                {
                    id: 'RESET_WORKFLOW',
                    label: 'Reset workflow',
                    info: 'Umožňuje resetovat celé workflow pokud došlo k přepnutí do jiného stavového diagramu a tím pádem je workflow nepoužitelné. Toto právo by měl mít pouze admin a to jen dočasně.',
                },
            ]
        },
    },
    mounted() {
        this.groups = orderBy(this.$store.getters.userGroups, ['name'], ['asc'])
    },
    methods: {
        onDone() {
            this.$router.push({ name: 'settingsStatesList' })
        },
        visibility(ptid, groupPropertyTypes) {
            return get(
                head(
                    filter(groupPropertyTypes, gpt => {
                        return get(gpt, 'propertyType.id') === ptid
                    })
                ),
                'visibility',
                0
            )
        },
        changeVisibility(ptid, groupPropertyTypes, gid) {
            let gpt = head(
                filter(groupPropertyTypes, gpt => {
                    return get(gpt, 'propertyType.id') === ptid
                })
            )
            if (gpt === undefined) {
                gpt = {
                    visibility: 0,
                    group: {
                        id: gid,
                    },
                    propertyType: {
                        id: ptid,
                    },
                }
                groupPropertyTypes.push(gpt)
            }
            const visibility = get(gpt, 'visibility', 0)
            if (visibility < 3) {
                this.$set(gpt, 'visibility', visibility + 1)
            } else {
                this.$set(gpt, 'visibility', 0)
            }
        },
        async save() {
            try {
                await Promise.all(map(this.groups, g => this.$store.dispatch('saveAcl', g)))
                await this.$store.dispatch('aclLoad')
                this.flash('Uloženo', 'success', {
                    timeout: 1500,
                })
                this.$emit('done')
                this.groups = orderBy(this.$store.getters.userGroups, ['name'], ['asc'])
                window.location.reload()
            } catch (e) {
                this.flash(`Nepovedlo se [${e.message}]`, 'error')
                throw e
            }
        },
        async add() {
            try {
                await this.$store.dispatch('addAcl', {})
                await this.$store.dispatch('aclLoad')
                this.groups = orderBy(this.$store.getters.userGroups, ['name'], ['asc'])
                this.flash('Nova skupina vytvorena', 'success', {
                    timeout: 1500,
                })
            } catch (e) {
                this.flash(`Nepovedlo se [${e.message}]`, 'error')
                throw e
            }
        },
        async deleteGroup(id) {
            try {
                await this.$store.dispatch('deleteAcl', id)
                await this.$store.dispatch('aclLoad')
                this.groups = orderBy(this.$store.getters.userGroups, ['name'], ['asc'])
                this.flash('Skupina vymazana', 'success', {
                    timeout: 1500,
                })
            } catch (e) {
                if (e === 'FOREIGN_KEY_ERROR') {
                    this.flash(`Chyba, na tuto skupinu jsou už navázané další položky.`, 'error')
                } else {
                    this.flash(`Obecná chyba při mazání.`, 'error')
                }
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.visibility-box {
    border: 1px solid gray;
    border-radius: 3px;
    margin: 2px;
    cursor: pointer;
}
.visibility-box:hover {
    background-color: lightgray;
}
.visibility-0 {
    color: RoyalBlue;
}
.visibility-1 {
    color: green;
}
.visibility-2 {
    color: orangered;
}
.visibility-3 {
    color: darkred;
}
.visibilities-editor {
    display: flex;
    flex-wrap: wrap;
}
</style>
